import React from "react"
import styles from "./teleworkspeakers.module.css"

const TeleworkSpeakers = ( { speakers }) => {
    return (
        <section className={styles.speakers} id="Speakers">
            <div className={styles.containfix}>
                <h1>SPEAKERS</h1>
                <div className={styles.wrapper}>
                    {speakers && speakers.map( (speakerData, index) => {
                        
                        return (!speakerData.disabledProfile && speakerData.event == "july" && <Speaker key={index} profile={speakerData} />)
                    }
                    )}
                </div>
                <p className={styles.pending}>* Pending Agency Approval</p>
            </div>
        </section>
    )
}

const Speaker = ( { profile } ) => (
    <div className={styles.profile}>
        <img src={profile.image} alt={profile.name} />
        <div className={styles.name}>{profile.name}</div>
        <div className={styles.title}>{profile.title}</div>
    </div>
)
export default TeleworkSpeakers